export default __webpack_public_path__ + "static/media/zonapro-light.75fb8f9c.otf";